namespace GeniuzPOS.Member {
    export class PsMemberTypeColumns {
        static columnsKey = 'Member.PsMemberType';
    }
}
